import React, { useState } from "react";
import styles from "./modal.module.css";
import { Link } from "react-router-dom";

const CustomModal = ({
  isOpen,
  onClose,
  imageUrl,
  title,
  description,
  siteUrl,
  logo,
}) => {
  const [isClosing, setIsClosing] = useState(false);

  if (!isOpen && !isClosing) return null;

  const handleModalContentClick = (e) => {
    e.stopPropagation();
  };

  const handleClose = () => {
    setIsClosing(true);
    // Wait for animation to complete before actually closing
    setTimeout(() => {
      setIsClosing(false);
      onClose();
    }, 1000); // Match this to your longest animation duration (1s)
  };

  return (
    <div
      className={`${styles.modalBackdrop} ${isClosing ? styles.closing : ""}`}
      onClick={handleClose}
    >
      <div
        className={`${styles.modalContent} ${isClosing ? styles.closing : ""}`}
        onClick={handleModalContentClick}
      >
        <div className={styles.modalBody}>
          <img
            src={imageUrl}
            alt={title}
            className={`${styles.modalImage} ${
              isClosing ? styles.closing : ""
            }`}
          />
          <div
            className={`${styles.modalText} ${isClosing ? styles.closing : ""}`}
          >
            <div className={styles.modalTextContent}>
              <div className={styles.modalTitleContent}>
                <h2>{title}</h2>
                <img src={logo} className={styles.logo} />
              </div>
              <p>{description}</p>
            </div>
            <div className={styles.modalBtnSection}>
              {siteUrl !== "" && (
                <a href={siteUrl} target="_blank" rel="noopener noreferrer">
                  <button className={styles.modalBtn}>Continue to Site</button>
                </a>
              )}
              <button onClick={handleClose} className={styles.modalBtn}>
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
